import React from "react"

import "./style.css";
import TargetImg from '../../assets/images/target.svg'

import Header from "../Header";
import Footer from "../Footer";
import CallToAction from "../CallToAction/CallToAction";

const Vision = () => {
  let isLogin = localStorage.getItem('isLogin')
  const type = isLogin

  return (
    <div className="About">
      <Header type={type} />

      <section className="admn-about">
        <div className="container">
          <div className="admn-about__vision-mission">
            <div className="row">
              <div className="col-sm-12 col-lg-7 order-2 text-justify text-lg-left">
                <div className="admn-about__mission">
                  <h2>Mission</h2>
                  <p>To guide and support students in making their of choice of a career and college admission in India or overseas, that best match their potential, performance and preferences irrespective of the marks obtained in the qualifying examination while providing a plethora of choices of courses and colleges.</p>
                </div>
                <div className="admn-about__vision">
                  <h2 className="">Vision</h2>
                  <p>
                    Helping our customers achieve their life&apos;s aspirations and contribute to the development of India by choosing careers from more than 1,000 existing and emerging options, and opportunities for higher education from over 1000 universities and 42000 colleges in India and several times those number of universities and colleges overseas.
                  </p>
                </div>
              </div>
              <div className="col-sm-12 col-md-5 d-flex align-items-center order-1 order-lg-3 mb-3 mb-lg-0">
                <figure className="hero__img">
                  <img src={TargetImg} alt="hero banner" />
                </figure>
              </div>
            </div>
            <div className="admn-about__values">
              <h2 className="admn-about__values__heading" style={{ marginLeft: 20 }}>Values</h2>
              <div className="d-flex flex-wrap">
                <span className="admn-about__value">Integrity</span>
                <span className="admn-about__value">|</span>
                <span className="admn-about__value">Transparency</span>
                <span className="admn-about__value">|</span>
                <span className="admn-about__value">Professionalism</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CallToAction />

      <Footer />
    </div>
  )
}

export default Vision;



/** WEBPACK FOOTER **
 ** ./src/components/Vision/index.js
 **/